import { IVeriMapComponent } from "@directives/_map/veriMap/veriMapComponent/veriMap.component";
import { ITimelineEntry } from "@directives/_veri/v-timeline/v-timeline.component";
import { IGeofence } from "@interfaces/IGeofences";
import { IJourney } from "@interfaces/IJourney";
import { IRunBlockRootScope } from "@interfaces/IRunBlockRootScope";
import { IGeofenceVisit } from "@services/geofence.service";
import { IHistoricalDay, JourneyService } from "@services/journey.service";
import { NavigationService } from "@services/navigation.service";
import { PrintService } from "@services/print.service";
import { TranslationService } from "@services/translation.service";
import { VeriDate } from "@services/veriDate.service";
import { RouteStatus } from "@tms/_enums/RouteStatus";
import { RouteVisitStatus } from "@tms/_enums/RouteVisitStatus";
import { VisitMatchOptions } from "@tms/_enums/VisitMatchOptions";
import { IGeoArea } from "@tms/_models/IGeoArea";
import { VisitType } from "@tms/_models/IPlannedRoute";
import { IPlannedRouteNote } from "@tms/_models/IPlannedRouteNote";
import { IRouteDetailVisit } from "../../_models/IRouteDetailVisit";
import { PlannedRouteNoteService } from "@tms/_services/planned-route-note.service";
import {
    IPlannedRouteDetail,
    PlannedRouteService,
} from "@tms/_services/planned-route.service";
import { VisitOnTimeStatus } from "../../_enums/VisitOnTimeStatus";
import * as angular from "angular";
import * as moment from "moment";
import "./routeDetails.scss";
import { IPlot } from "@interfaces/IPlot";
import {
    UnitConversionType,
    UnitConversionService,
} from "@services/unitConversion.service";
import { UserAccessType } from "@tms/_enums/UserAccessType";
import { DisplayService, IDialogOptionsJson } from "@services/display.service";
import { TmsModuleNavigation } from "@tms/tms.navigation";
import {
    AccountFeatureService,
    FeatureAccessType,
} from "@services/accountFeature.service";
import { AccountFeatures } from "@enums/account/AccountFeature";
import { PlannedRouteService2 } from "../../_services/planned-route.service2";
import { PlannedRouteClosureReason } from "../../_enums/PlannedRouteClosureReason";

enum VisitFilter {
    All,
    Missed,
    Late,
    Early,
    Unplanned,
}

class RouteDetailsComponentController implements angular.IComponentController {
    routeId: number;
    route: IPlannedRouteDetail;

    noteLoading = false;
    noteString: string;

    actualFiguresAvailable = false;
    actualDistanceKm: number;
    actualDurationMins: number;

    showPlannedRoute = true;
    showActualRoute = false;

    showUnplannedStops = true;

    geofences: IGeofence[];
    geoAreas: IGeoArea[];
    geofenceVisits: IGeofenceVisit[];
    journeys: IJourney[];
    veriMap: IVeriMapComponent;

    timelineEntries: ITimelineEntry[] = [];
    showDriverSheet = false;

    pvaDiffMins: number;
    pvaDistanceDiff: number;
    missedVisitsCount: number;
    fuelConsumption: number;

    selectedVisit: IRouteDetailVisit;

    updateInterval: angular.IPromise<void>;
    routeIsInProgressOrPlanned = false;
    loading = false;
    visitsLoading = false;

    showSettings = false;
    showRespinButton = false;
    vehicleAndDriverMissing = false;
    canReallocateAssets = false;

    routeSettingsString: string = "";

    canCloseRoute = false;
    routeClosed = false;
    canShowSideBar = false;

    visitFilters = [
        {
            name: this.translationService.t("Tms.AllVisits"),
            value: VisitFilter.All,
        },
        {
            name: this.translationService.t("Tms.MissedVisits"),
            value: VisitFilter.Missed,
        },
        {
            name: this.translationService.t("Tms.LateVisits"),
            value: VisitFilter.Late,
        },
        {
            name: this.translationService.t("Tms.EarlyVisits"),
            value: VisitFilter.Early,
        },
        {
            name: this.translationService.t("Tms.UnplannedStops"),
            value: VisitFilter.Unplanned,
        },
    ];

    selectedVisitFilter: VisitFilter;
    filteredVisits: IRouteDetailVisit[];

    odoStart: number;
    odoEnd: number;

    canManageTMS: boolean;

    static $inject = [
        "$scope",
        "$element",
        "$rootScope",
        "$q",
        "$interval",
        "$mdDialog",
        "veriDate",
        "displayService",
        "plannedRouteService",
        "journeyService",
        "printService",
        "navigationService",
        "$timeout",
        "translationService",
        "plannedRouteNoteService",
        "unitConversionService",
        "accountFeatureService",
        "plannedRouteService2",
    ];

    constructor(
        private readonly $scope: angular.IScope,
        private readonly $element: JQuery,
        private readonly $rootScope: IRunBlockRootScope,
        private readonly $q: angular.IQService,
        private readonly $interval: angular.IIntervalService,
        private readonly $mdDialog: angular.material.IDialogService,
        private readonly veriDate: VeriDate,
        private readonly displayService: DisplayService,
        private readonly plannedRouteService: PlannedRouteService,
        private readonly journeyService: JourneyService,
        private readonly printService: PrintService,
        private readonly navigationService: NavigationService,
        private readonly $timeout: angular.ITimeoutService,
        private readonly translationService: TranslationService,
        private readonly plannedRouteNoteService: PlannedRouteNoteService,
        private readonly unitConversionService: UnitConversionService,
        private readonly accountFeatureService: AccountFeatureService,
        private readonly plannedRouteService2: PlannedRouteService2
    ) {}

    $onInit(): void {
        this.canManageTMS =
            this.accountFeatureService.currentUserHasFeatureAccess(
                AccountFeatures.TMS,
                FeatureAccessType.Manage
            );

        this.getData(true);
        this.selectedVisitFilter = VisitFilter.All;
        this.routeSettingsString = this.getRouteSettingsString();
    }

    $onDestroy(): void {
        if (this.updateInterval) {
            this.$interval.cancel(this.updateInterval);
        }
    }

    edit(): void {
        this.navigationService.go(TmsModuleNavigation.EditSchedule, {
            routeId: this.route.Id,
        });
    }

    replayRoute(): void {
        this.loading = true;
        this.plannedRouteService
            .replayRoute(this.routeId, true)
            .then((result) => {
                this.getData(true);
            });
    }

    setSelectedVisit(visit: IRouteDetailVisit) {
        if (this.vehicleAndDriverMissing) {
            return;
        }
        this.selectedVisit = visit;
        this.$element.scrollTop(0);
        this.panToVisit();
    }

    visitFilterChanged() {
        this.selectedVisitFilter = +this.selectedVisitFilter;
        this.filterDisplayVisits();
    }

    assetChanged(result) {
        this.loading = true;
        if (result && result.source === "Vehicle") {
            this.route.VehicleId = result?.object ? result.object.Id : null;
            this.route.vehicle = result?.object ? result.object : null;
        }
        if (result && result.source === "Driver") {
            this.route.DriverId = result?.object ? result.object.Id : null;
            this.route.driver = result?.object ? result.object : null;
        }

        this.plannedRouteService.updatePlannedRoute(this.route).then(() => {
            this.getData();
        });
    }

    showQuickEdit() {
        const dialogOptions: IDialogOptionsJson = {
            title: this.route.routeDisplayName,
            dialogHTML: `<md-input-container class="md-block">
                            <veri-autocomplete include-vehicles="true"
                                               include-drivers="true"
                                               custom-place-holder-text="{{'Tms.AssignNewResource' | translate}}"
                                               on-select="$ctrl.assetChanged($match); $ctrl.hide();"
                                               search-on-click="true">
                            </veri-autocomplete>
                        </md-input-container>`,
            dialogId: `routeDriverVehicleEditor`,
            customClass: `route-driver-vehicle-editor-dialog`,
            bindings: {
                assetChanged: ($match) => {
                    this.assetChanged($match);
                },
            },
        };

        return this.displayService.showDialog(dialogOptions);
    }

    mapIdle(veriMap: IVeriMapComponent) {
        this.veriMap = veriMap;
    }

    printDas() {
        this.showDriverSheet = true;
        this.$timeout(() => {
            this.printService.print("driver-activity-sheet");

            this.showDriverSheet = false;
        }, 100);
    }

    addNote(note: string) {
        const plannedNote: IPlannedRouteNote = {
            Note: note,
            PlannedRouteId: this.route.Id,
            UserId: this.$rootScope.currentUser.Id,
        };

        this.noteString = "";

        this.noteLoading = true;
        this.plannedRouteNoteService
            .addPlannedRouteNotes(this.route.Id, plannedNote)
            .finally(() => {
                this.noteLoading = false;
                this.updateNotes();
            });
    }

    updateNotes() {
        this.noteLoading = true;

        this.plannedRouteNoteService
            .getNotesForPlannedRoute(this.route.Id)
            .then((notes) => {
                this.route.PlannedRouteNotes = notes;
            })
            .finally(() => {
                this.noteLoading = false;
                this.setupTimeline();
            });
    }

    setPlannedRouteEditable() {
        this.route.editingDisabled = false;

        if (
            this.route.Status === RouteStatus.Completed ||
            this.route.Status === RouteStatus.CompletedWithMissing ||
            this.route.Status === RouteStatus.Expired ||
            this.route.Status === RouteStatus.Cancelled ||
            this.route.Status === RouteStatus.Incomplete
        ) {
            this.route.editingDisabled = true;
        }
    }

    getVisitAddressString(visit: IRouteDetailVisit) {
        if (visit.visitType == VisitType.Planned && visit.address) {
            return visit.address;
        } else if (visit.visitType == VisitType.Unplanned) {
            return "";
        } else {
            return visit.displayName ?? "Address unavailable";
        }
    }

    getRouteSettingsString(): string {
        if (!this.route || !this.route.TmsRouteRules?.RouteMatchingRules) {
            return "No settings saved";
        }

        let settingsString = "";

        settingsString += this.createStartRuleString();
        settingsString += this.createEndRuleString();
        settingsString += this.createArriveVisitRuleString();

        if (this.route.TmsRouteRules.VisitMatchingRules.RecordUnplannedVisits) {
            settingsString += this.createRuleString(
                this.translationService.t(
                    "SchedulingService.RecordUnplannedVisits"
                )
            );
        }

        if (
            this.route.TmsRouteRules.VisitMatchingRules.CanMatchOnMissedVisits
        ) {
            settingsString += this.createRuleString(
                this.translationService.t(
                    "SchedulingService.MatchOnMissedVisits"
                )
            );
        }

        if (
            this.route.TmsRouteRules.VisitMatchingRules
                .RecordVisitsAsMissedIfVisitedOutOfOrder
        ) {
            settingsString += this.createRuleString(
                this.translationService.t(
                    "SchedulingService.VisitsMissedIfVisitedOutOfOrder"
                )
            );
        }

        if (
            this.route.TmsRouteRules.VisitMatchingRules
                .RestartRouteOnReturnToStartingLocation
        ) {
            settingsString += this.createRuleString(
                this.translationService.t(
                    "SchedulingService.RestartRouteOnReturnToStart"
                )
            );
        }

        settingsString += this.startingPeriodTimeRuleString();
        const maximumLateTimeAllowedMins = this.veriDate.convertTimeSpanToMins(
            this.route.TmsRouteRules.RouteExpiryRules.MaximumLateTimeAllowed
        );
        const maximumExpiryTime = this.veriDate
            .createMoment(
                this.route.TmsRouteRules.RouteExpiryRules.MaximumExpiryTime
            )
            .add("minutes", maximumLateTimeAllowedMins);

        settingsString += this.createRuleString(
            `${this.translationService.t(
                "SchedulingService.MaximumExpiryTime"
            )}: ${this.veriDate.formatDate(maximumExpiryTime, "time")}`
        );

        settingsString += `<H2>${this.translationService.t(
            "SchedulingService.VisitTimes"
        )}</H2>`;

        this.route.PlannedVisits.forEach((visit) => {
            var arrival = this.veriDate.createMoment(visit.PlannedArrivalTime);
            var departure = this.veriDate.createMoment(
                visit.PlannedDepartureTime
            );

            var onSiteTimeMins = this.veriDate.convertTimeSpanToMins(
                visit.OnSiteTimeBuffer
            );
            var travelTimeBufferMins = this.veriDate.convertTimeSpanToMins(
                visit.TravelTimeBuffer
            );

            settingsString += `${this.translationService.t(
                "SchedulingService.Visit"
            )}: ${visit.Name || visit.Address}`;
            settingsString += this.createRuleString(
                `${this.translationService.t(
                    "SchedulingService.ArrivalTimeWindow"
                )}: ${this.veriDate.formatDate(
                    arrival.subtract("minutes", travelTimeBufferMins),
                    "time"
                )} - ${this.veriDate.formatDate(
                    arrival.add("minutes", travelTimeBufferMins),
                    "time"
                )}`
            );
            settingsString += this.createRuleString(
                `${this.translationService.t(
                    "SchedulingService.DepartureTimeWindow"
                )}: ${this.veriDate.formatDate(
                    departure.subtract("minutes", onSiteTimeMins),
                    "time"
                )} - ${this.veriDate.formatDate(
                    departure.add("minutes", onSiteTimeMins),
                    "time"
                )} `
            );
            settingsString += "<br/>";
        });

        return settingsString;
    }

    toggleSettings($event: MouseEvent) {
        const dialog = this.$mdDialog
            .confirm()
            .multiple(true)
            .title("Route settings")
            .htmlContent(this.routeSettingsString)
            .targetEvent($event)
            .ok("Close");

        this.$mdDialog.show(dialog);
    }

    openSideBar() : void{
        this.canShowSideBar = true;
        this.$scope.$apply();
    }

    closeSideBar() : void{
        this.canShowSideBar = false;
        this.route.plannedRouteClosureReason = null;
        this.$scope.$applyAsync();
    }

    closeRoute(): void {
        if(this.route.plannedRouteClosureReason){
            const dialog = this.$mdDialog
             .confirm()
             .title(this.translationService.t("Tms.CloseRoute"))
             .textContent(this.translationService.t("Tms.ConfirmCloseRoute"))
             .ok(this.translationService.t("Tms.CloseRoute"))
             .cancel(this.translationService.t("Common.Cancel"));
             
             this.$mdDialog
             .show(dialog)
             .then(() => {
                    this.canShowSideBar = false;
                    this.route.Status = RouteStatus.Closed;
                    this.loading = true;
                    this.plannedRouteService.updatePlannedRoute(this.route).then(() => {
                        this.plannedRouteService2.updatePlannedRouteCache(this.route); 
                        this.$timeout(() => {
                            this.getData(true);  
                        }, 1000);
                    });
                 },
                 () => {
                    this.canShowSideBar = false;
                 });          
        }
    }

    private createStartRuleString(): string {
        let settingsString = "";

        if (
            this.route.TmsRouteRules.RouteMatchingRules
                .StartRouteOnDepartStartingLocation
        ) {
            settingsString += this.createRuleString(
                this.translationService.t(
                    "SchedulingService.StartRouteOnDepartStartingLocation"
                )
            );
        }
        if (
            this.route.TmsRouteRules.RouteMatchingRules
                .StartRouteOnArriveAnyVisitLocation
        ) {
            settingsString += this.createRuleString(
                this.translationService.t(
                    "SchedulingService.StartRouteOnArriveAnyVisitLocation"
                )
            );
        }
        if (
            this.route.TmsRouteRules.RouteMatchingRules
                .StartRouteOnDepartAnyVisitLocation
        ) {
            settingsString += this.createRuleString(
                this.translationService.t(
                    "SchedulingService.StartRouteOnDepartAnyVisitLocation"
                )
            );
        }
        if (
            this.route.TmsRouteRules.RouteMatchingRules.StartRouteOnJourneyStart
        ) {
            settingsString += this.createRuleString(
                this.translationService.t(
                    "SchedulingService.StartRouteOnJourneyStart"
                )
            );
        }

        return settingsString;
    }

    private createEndRuleString(): string {
        let settingsString = "";

        if (
            this.route.TmsRouteRules.RouteMatchingRules
                .EndRouteOnAllVisitsArrived
        ) {
            settingsString += this.createRuleString(
                this.translationService.t(
                    "SchedulingService.EndRouteOnAllVisitsArrived"
                )
            );
        }
        if (
            this.route.TmsRouteRules.RouteMatchingRules
                .EndRouteOnAllVisitsDeparted
        ) {
            settingsString += this.createRuleString(
                this.translationService.t(
                    "SchedulingService.EndRouteOnAllVisitsDeparted"
                )
            );
        }
        if (
            this.route.TmsRouteRules.RouteMatchingRules
                .EndRouteOnArriveAtEndingLocation
        ) {
            settingsString += this.createRuleString(
                this.translationService.t(
                    "SchedulingService.EndRouteOnArriveAtEndingLocation"
                )
            );
        }
        if (
            this.route.TmsRouteRules.RouteMatchingRules
                .EndRouteOnDepartAtEndingLocation
        ) {
            settingsString += this.createRuleString(
                this.translationService.t(
                    "SchedulingService.EndRouteOnDepartAtEndingLocation"
                )
            );
        }

        return settingsString;
    }

    private createArriveVisitRuleString() {
        switch (this.route.TmsRouteRules.VisitMatchingRules.ArriveOn) {
            case VisitMatchOptions.OnLocation:
                return this.createRuleString(
                    this.translationService.t(
                        "SchedulingService.ArriveVisitOnLocation"
                    )
                );
            case VisitMatchOptions.OnJourney:
                return this.createRuleString(
                    this.translationService.t(
                        "SchedulingService.ArriveVisitOnJourney"
                    )
                );
            case VisitMatchOptions.OnDwell:
                return this.createRuleString(
                    this.translationService.t(
                        "SchedulingService.ArriveVisitOnDwell"
                    )
                );
        }

        return "";
    }

    private startingPeriodTimeRuleString() {
        const start = this.veriDate.formatDate(
            this.route.TmsRouteRules.RouteMatchingRules.MinimumStartTime,
            "time"
        );
        const end = this.veriDate.formatDate(
            this.route.TmsRouteRules.RouteExpiryRules.MaximumStartTime,
            "time"
        );

        return this.createRuleString(
            `${this.translationService.t(
                "SchedulingService.StartingPeriod"
            )}: ${start} - ${end}`
        );
    }

    private createRuleString(ruleValue: string): string {
        const lineStart = "<li>";
        const lineEnd = ".</li>";

        return `${lineStart}${ruleValue}${lineEnd}`;
    }

    private getData(showLoadingSpinner = false) {
        if (showLoadingSpinner) {
            this.loading = true;
        }
        this.plannedRouteService
            .getPlannedRoute(this.routeId, {
                mapDrivers: true,
                mapVehicles: true,
                mapGeofences: true,
                getUnplannedStops: true,
                geocodeUnplannedStops: true,
                updateLinePoints: true,
                showCancelledRoutes: true
            })
            .then((route) => {
                this.route = route;
                this.loadData();

                this.setIntervalIfRouteInProgress();
                this.routeIsInProgressOrPlanned =
                    this.isRouteInProgressOrPlanned();
                this.navigationService.updateBreadcrumbNameResolver({
                    routeNameKey: this.route.Name,
                });

                this.setupTimeline();
            })
            .finally(() => {
                this.filterDisplayVisits();
                this.routeClosed = this.route.Status === RouteStatus.Closed;
                this.vehicleAndDriverMissing =
                    !this.route.vehicle && !this.route.driver;
                this.canReallocateAssets =
                    !this.routeClosed &&
                    this.route.editingDisabled &&
                    this.vehicleAndDriverMissing;
                this.showRespinButton =
                    !this.routeClosed &&
                    !this.vehicleAndDriverMissing &&
                    this.canManageTMS &&
                    (this.isRouteCreatedAfterStart() ||
                        this.isRouteInChangebleState());
                this.canCloseRoute = this.canManageTMS && !(
                    this.route.Status == RouteStatus.Completed ||
                    this.route.Status == RouteStatus.Incomplete ||
                    this.route.Status == RouteStatus.CompletedWithMissing ||
                    this.routeClosed 
                );

                this.loading = false;
            });
    }

    private isRouteInChangebleState(): boolean {
        if (!this.route) {
            return false;
        }

        var changebleStates = [
            RouteStatus.Expired,
            RouteStatus.Draft,
            RouteStatus.Planned,
            RouteStatus.UserExpired,
            RouteStatus.Incomplete,
        ];

        if (changebleStates.indexOf(this.route.Status) != -1) {
            return true;
        }
        return false;
    }

    private loadData() {
        this.setPlannedRouteEditable();
        this.setActualData();
        this.updateJourneys();
        this.updateNotes();
        this.geoAreas = this.plannedRouteService.extractGeoAreasFromRoute(
            this.route
        );
        this.setupTimeline();
        this.checkIfVehicleIsAtVisitLocation();
        this.getDashboardFigures();
        this.routeSettingsString = this.getRouteSettingsString();

        if (this.route.unplannedVisits.length === 0) {
            this.showUnplannedStops = false;
        }

        if (this.updateInterval && this.route.Status !== RouteStatus.Started) {
            this.$interval.cancel(this.updateInterval);
        }
    }

    private filterDisplayVisits() {
        this.visitsLoading = true;
        switch (this.selectedVisitFilter) {
            case VisitFilter.All:
                this.filteredVisits = this.route.allVisits.filter((visit) => {
                    return visit.visitType === VisitType.Planned;
                });
                break;
            case VisitFilter.Missed:
                this.filteredVisits = this.route.allVisits.filter((visit) => {
                    return (
                        visit.visitType === VisitType.Planned &&
                        visit.arrivalTimeStatus === VisitOnTimeStatus.Missed
                    );
                });
                break;
            case VisitFilter.Early:
                this.filteredVisits = this.route.allVisits.filter((visit) => {
                    return (
                        visit.visitType === VisitType.Planned &&
                        visit.arrivalTimeStatus === VisitOnTimeStatus.Early
                    );
                });
                break;
            case VisitFilter.Late:
                this.filteredVisits = this.route.allVisits.filter((visit) => {
                    return (
                        visit.visitType === VisitType.Planned &&
                        visit.arrivalTimeStatus === VisitOnTimeStatus.Late
                    );
                });
                break;
            case VisitFilter.Unplanned:
                this.filteredVisits = this.route.allVisits.filter((visit) => {
                    return visit.visitType === VisitType.Unplanned;
                });
                break;
            default:
                this.filteredVisits = this.route.allVisits;
                break;
        }
        this.$timeout(() => {
            this.visitsLoading = false;
        }, 600);
    }

    private panToVisit(): void {
        const latLng = new google.maps.LatLng(
            this.selectedVisit.latitude,
            this.selectedVisit.longitude
        );

        this.veriMap.smoothPanAndZoomTo(latLng, 16);

        this.selectedVisit = null;
    }

    private setIntervalIfRouteInProgress() {
        if (this.route.Status === RouteStatus.Started) {
            this.updateInterval = this.$interval(() => {
                this.loadData();
            }, 60000);
        }
    }

    private checkIfVehicleIsAtVisitLocation() {
        if (this.route.Status !== RouteStatus.Started) {
            return;
        }
        this.route.allVisits.forEach((visit) => {
            if (
                visit.actualArrivalTime &&
                !visit.actualDepartureTime &&
                visit !== this.route.lastVisit
            ) {
                visit.vehiclePresent = true;
            } else {
                visit.vehiclePresent = false;
            }
        });
    }

    private isRouteInProgressOrPlanned() {
        if (
            this.route.Status === RouteStatus.Planned ||
            this.route.Status === RouteStatus.Started
        ) {
            return true;
        }
    }

    private isRouteCreatedAfterStart(): boolean {
        return this.veriDate
            .createMoment(this.route.CreationDateTime)
            .isAfter(this.route.PlannedStartTime);
    }

    private getDashboardFigures() {
        if (!this.route.allVisits?.length) {
            return;
        }

        this.getPvaTime();
        this.getPvaDistance();
        this.getMissedVisitsCount();
        this.getFuelConsumption();
    }

    private setVisitComments(plots: IPlot[]) {
        this.route.allVisits.forEach((visit, index) => {
            if (
                visit.actualArrivalTime &&
                visit.visitType !== VisitType.Unplanned
            ) {
                visit.arrivalComment = this.buildStringForVisitComment(
                    this.translationService.t("Tms.Arrived"),
                    this.veriDate.createMoment(visit.actualArrivalTime),
                    this.veriDate.createMoment(visit.plannedArrivalTime),
                    visit.arrivalTimeStatus
                );
            } else if (
                !visit.actualArrivalTime &&
                visit.arrivalEta &&
                visit.status === RouteVisitStatus.Planned
            ) {
                visit.arrivalComment = this.buildStringForVisitComment(
                    this.translationService.t("Tms.ETA"),
                    this.veriDate.createMoment(visit.arrivalEta)
                );
            } else {
                visit.arrivalComment = "";
            }
            if (
                visit.actualDepartureTime &&
                visit.visitType !== VisitType.Unplanned
            ) {
                visit.departureComment = this.buildStringForVisitComment(
                    this.translationService.t("Tms.Departed"),
                    this.veriDate.createMoment(visit.actualDepartureTime),
                    this.veriDate.createMoment(visit.plannedDepartureTime),
                    visit.departureTimeStatus
                );
            } else if (visit.visitType === VisitType.Unplanned) {
                visit.departureComment =
                    this.translationService.t("Tms.UnplannedVisit");
            } else if (visit.vehiclePresent) {
                const timeOnSite = this.veriDate
                    .createMoment(visit.plannedDepartureTime)
                    .diff(visit.plannedArrivalTime);
                const expectedDepartureTime = this.veriDate
                    .createMoment(visit.actualArrivalTime)
                    .add(timeOnSite);
                visit.departureComment = this.buildStringForVisitComment(
                    this.translationService.t("Tms.EstimatedDeparture"),
                    expectedDepartureTime
                );
            } else {
                visit.departureComment = "";
            }

            if (visit.status === RouteVisitStatus.Missed) {
                visit.arrivalComment =
                    this.translationService.t("Tms.VisitMissed");

                this.updateDistanceFromComment(plots, visit);
            }

            if (
                this.route.Status === RouteStatus.Expired &&
                index === 0 &&
                !visit.actualDepartureTime
            ) {
                this.updateDistanceFromComment(plots, visit);
            }

            if (
                !visit.arrivalComment &&
                visit.arrivalTimeStatus === VisitOnTimeStatus.OnTime
            ) {
                visit.arrivalComment = this.buildStringForVisitComment(
                    this.translationService.t("Tms.Arrived"),
                    null,
                    null,
                    visit.arrivalTimeStatus
                );
            }

            if (
                !visit.departureComment &&
                visit.departureTimeStatus === VisitOnTimeStatus.OnTime
            ) {
                visit.departureComment = this.buildStringForVisitComment(
                    this.translationService.t("Tms.Departed"),
                    null,
                    null,
                    visit.departureTimeStatus
                );
            }
        });
    }

    updateDistanceFromComment(plots: IPlot[], visit: IRouteDetailVisit) {
        const distanceFrom = this.getDistanceFromVisitLocation(plots, visit);
        if (distanceFrom) {
            const distanceNumber = this.unitConversionService.convertToUserUnit(
                distanceFrom.distanceFrom / 1000,
                UnitConversionType.Distance
            );
            let distanceString = distanceNumber.toString();
            if (distanceNumber < 1) {
                distanceString = "< 1";
            }
            const distanceLabel = this.unitConversionService.getConversionLabel(
                UnitConversionType.Distance
            );

            visit.arrivalComment = `Vehicle was ${distanceString} ${distanceLabel} away at ${this.veriDate.formatDate(
                distanceFrom.plot.Utc
            )}`;
        }
    }

    handleClosureReasonChange(plannedRouteClosureReason: PlannedRouteClosureReason) {
        this.route.plannedRouteClosureReason = plannedRouteClosureReason;
        this.$scope.$apply();
    }

    private getDistanceFromVisitLocation(
        plots: IPlot[],
        visit: IRouteDetailVisit
    ): { plot: IPlot; distanceFrom: number } {
        const startAndEndTime = this.getRouteStartAndEndTime();
        const startTime = startAndEndTime.startTime;
        const endTime = startAndEndTime.endTime;

        var returnValue: { plot: IPlot; distanceFrom: number } = null;

        plots.forEach((plot) => {
            if (
                plot.UtcMoment.isAfter(startTime) &&
                plot.UtcMoment.isBefore(endTime)
            ) {
                const geofenceLatLng = new google.maps.LatLng(
                    visit.latitude,
                    visit.longitude
                );
                const plotLatLng = new google.maps.LatLng(
                    plot.Latitude,
                    plot.Longitude
                );

                const distance =
                    google.maps.geometry.spherical.computeDistanceBetween(
                        geofenceLatLng,
                        plotLatLng
                    );

                const comparisonValue = returnValue
                    ? returnValue.distanceFrom
                    : Number.MAX_SAFE_INTEGER;

                if (distance < comparisonValue) {
                    returnValue = { plot: plot, distanceFrom: distance };
                }
            }
        });

        return returnValue;
    }

    private buildStringForVisitComment(
        type: string,
        time1: moment.Moment,
        time2?: moment.Moment,
        onTimeStatus?: VisitOnTimeStatus
    ) {
        if (time2) {
            const differenceMinutes = time1.diff(time2) / 1000 / 60;

            let status: string;
            switch (onTimeStatus) {
                case VisitOnTimeStatus.Early:
                    status = this.translationService.t("Tms.Early");
                    break;
                case VisitOnTimeStatus.Late:
                    status = this.translationService.t("Tms.Late");
                    break;
                default:
                    return "";
            }

            if (
                onTimeStatus === VisitOnTimeStatus.Early ||
                onTimeStatus === VisitOnTimeStatus.Late
            ) {
                return `${type} ${this.veriDate.formatDurationMs(
                    Math.abs(differenceMinutes) * 60 * 1000
                )} ${status}`;
            }
        } else if (onTimeStatus === VisitOnTimeStatus.OnTime) {
            const onTimeString = this.translationService.t("Tms.OnTime");
            return `${type} ${onTimeString}`;
        } else {
            return `${type} ${this.veriDate.formatDate(time1, "time")}`;
        }
    }

    private getPvaTime() {
        const firstPlannedStop =
            this.route.firstVisit || this.route.PlannedVisits[0];
        const lastPlannedStop =
            this.route.lastVisit ||
            this.route.PlannedVisits[this.route.PlannedVisits.length - 1];
        this.route.plannedDuration = this.veriDate.getDiff(
            firstPlannedStop.PlannedDepartureTime,
            lastPlannedStop.PlannedArrivalTime,
            "m"
        );
        this.route.actualDuration = this.route.totalDurationMins;
        this.pvaDiffMins =
            this.route.totalDurationMins - this.route.plannedDuration;
    }

    private getPvaDistance() {
        this.pvaDistanceDiff =
            this.actualDistanceKm - this.route.totalPlannedDistanceKm;
    }

    private getMissedVisitsCount() {
        this.missedVisitsCount = this.route.PlannedVisits.filter((visit) => {
            return visit.Status === RouteVisitStatus.Missed;
        }).length;
    }

    private getFuelConsumption() {
        this.fuelConsumption = 0;
        if (this.journeys?.length) {
            this.journeys.forEach((journey) => {
                if (journey.FuelUsedTotal) {
                    this.fuelConsumption += journey.FuelUsedTotal;
                }
            });
        }
    }

    private setActualData() {
        if (this.journeys?.length) {
            this.actualFiguresAvailable = true;
        }

        this.actualDistanceKm = 0;
        this.actualDurationMins = 0;

        if (this.actualFiguresAvailable) {
            this.journeys?.forEach((journey) => {
                this.actualDistanceKm += journey.DistanceKm || journey.Distance;
            });
            let startTime: moment.Moment;
            let endTime: moment.Moment;

            if (this.route.ActualStartTime) {
                startTime = this.veriDate.createMoment(
                    this.route.ActualStartTime
                );
            }

            if (this.route.ActualEndTime) {
                endTime = this.veriDate.createMoment(this.route.ActualEndTime);
            } else if (this.route.Status === RouteStatus.Started) {
                endTime = this.veriDate.createMoment(new Date());
            } else {
                endTime = this.veriDate.createMoment(
                    this.route.allVisits[this.route.allVisits.length - 1]
                        .actualArrivalTime
                );
            }

            if (startTime && endTime) {
                this.actualDurationMins = endTime.diff(startTime, "minute");
            }
            this.showActualRoute = true;
        }
    }

    private getRouteStartAndEndTime(): {
        startTime: moment.Moment;
        endTime: moment.Moment;
    } {
        // Get the times from which we need to show our actual journey

        let startTime = this.veriDate.createMoment(this.route.PlannedStartTime);

        if (
            this.route.ActualStartTime &&
            this.route.Status !== RouteStatus.Planned &&
            this.route.Status !== RouteStatus.Expired &&
            this.route.Status !== RouteStatus.Cancelled
        ) {
            startTime = this.veriDate.createMoment(this.route.ActualStartTime);
        }

        const lastVisit = this.route.lastVisit;

        let endTime: moment.Moment;

        if (this.route.ActualEndTime) {
            endTime = this.veriDate.createMoment(this.route.ActualEndTime);
        } else if (!this.route.ActualEndTime && lastVisit.ActualArrivalTime) {
            endTime = this.veriDate.createMoment(lastVisit.ActualArrivalTime);
        } else {
            endTime = this.veriDate.createMoment(lastVisit.PlannedArrivalTime);
        }

        if (this.route.Status == RouteStatus.Planned) {
            const journeyBufferMins = 60;
            startTime.add(-journeyBufferMins, "m");
            endTime.add(journeyBufferMins, "m");
        }

        return {
            startTime: startTime,
            endTime: endTime,
        };
    }

    private updateJourneys() {
        this.journeys = [];

        const startAndEndTime = this.getRouteStartAndEndTime();
        const startTime = startAndEndTime.startTime;
        const endTime = startAndEndTime.endTime;

        // We need to account for journeys spanning multiple days
        let historicalDayPromise: angular.IPromise<IHistoricalDay> =
            this.$q.resolve(null);

        if (this.route.vehicle) {
            historicalDayPromise =
                this.journeyService.getHistoricalDayForVehicle(
                    this.route.vehicle,
                    startTime,
                    endTime,
                    true
                );
        } else if (this.route.driver) {
            historicalDayPromise = this.journeyService.getJourneyDataForDriver(
                this.route.driver.Id,
                startTime.toDate(),
                endTime.toDate()
            );
        }

        historicalDayPromise.then((historicalDay) => {
            this.journeys = [];

            if (!historicalDay) {
                return;
            }
            const historicalJourneys = historicalDay.journeyModel.journeys;

            // Only show ones that relate to the time frame we are looking at
            historicalJourneys.forEach((journey) => {
                if (
                    (startTime.isSameOrBefore(journey.StartUtc) &&
                        endTime.isSameOrAfter(journey.StartUtc)) ||
                    (startTime.isSameOrAfter(journey.StartUtc) &&
                        endTime.isSameOrBefore(journey.EndUtc)) ||
                    (startTime.isSameOrBefore(journey.EndUtc) &&
                        endTime.isSameOrAfter(journey.EndUtc))
                ) {
                    journey.lineColor = "#f16c20";

                    this.journeys.push(journey);
                }
            });
            this.setActualData();
            this.getDashboardFigures();
            this.setVisitComments(historicalDay.plots);
            this.setOdoFigures();
        });
    }

    private setOdoFigures() {
        if (!this.journeys || !this.journeys.length) {
            return;
        }
        this.odoStart = this.journeys[0].OdometerKmStart;
        this.odoEnd = this.journeys[this.journeys.length - 1].OdometerKmEnd;
    }

    private setupTimeline() {
        this.timelineEntries = [];

        if (!this.route) {
            return;
        }

        const standardSubject =
            this.route.driver?.Name ||
            this.route.vehicle?.ShortReg ||
            this.translationService.t("Common.Unknown");
        // Route creation
        if (
            this.route.CreationDateTime &&
            this.route.CreatedBy === UserAccessType.Api
        ) {
            this.timelineEntries.push({
                icon: "add_circle",
                date: new Date(this.route.CreationDateTime),
                inlineDetails: {
                    verb: this.translationService.t("Tms.ImportedVerb"),
                },
            });
        }

        // Start
        if (
            this.route.ActualStartTime &&
            this.route.Status !== RouteStatus.Planned &&
            this.route.Status !== RouteStatus.Expired &&
            this.route.Status !== RouteStatus.Cancelled
        ) {
            this.timelineEntries.push({
                icon: "play_arrow",
                date: new Date(this.route.ActualStartTime),
                inlineDetails: {
                    subject: standardSubject,
                    verb: this.translationService.t("Tms.StartedVerb"),
                    noun: this.translationService.t("Tms.Route"),
                },
            });
        }

        // Notes
        this.route.PlannedRouteNotes.forEach((note) => {
            this.timelineEntries.push({
                icon: "chat",
                date: note.Utc as any,
                largeDetails: {
                    title:
                        note.user?.CurrentAccountUserMapping.Name ||
                        this.translationService.t("Tms.System"),
                    text: note.Note,
                    verb: this.translationService.t("Tms.CommentedVerb"),
                },
            });
        });

        //Visits
        this.route.allVisits.forEach((visit, index) => {
            this.addVisitToTimeline(visit, index);
        });

        if (this.route.ActualEndTime) {
            this.timelineEntries.push({
                icon: "stop",
                date: new Date(this.route.ActualEndTime),
                inlineDetails: {
                    subject: standardSubject,
                    verb: this.translationService.t("Tms.EndedVerb"),
                    noun: this.translationService.t("Tms.Route"),
                },
            });
        }

        // Last update
        if (this.route.LastUpdateDateTime) {
            this.timelineEntries.push({
                icon: "edit",
                date: new Date(this.route.LastUpdateDateTime),
                inlineDetails: {
                    verb: this.translationService.t("Tms.LastUpdatedVerb"),
                },
            });
        }
    }

    private addVisitToTimeline(visit: IRouteDetailVisit, index: number) {
        if (!visit.actualArrivalTime && !visit.actualDepartureTime) {
            return;
        }

        const planned = visit.visitType === VisitType.Planned;

        const entry: ITimelineEntry = {
            icon: planned ? "place" : "question_mark",
            date:
                index === 0
                    ? visit.actualDepartureTime
                    : visit.actualArrivalTime, //use departure time if visit is first visit
            largeDetails: {
                title: planned
                    ? this.translationService.t("Tms.PlannedVisit")
                    : this.translationService.t("Tms.UnplannedStop"),
                text: visit.displayName,
                listItems: [],
            },
        };

        let arriveDepartText = "";
        if (visit.actualArrivalTime) {
            if (!visit.actualDepartureTime) {
                arriveDepartText = this.translationService.t("Tms.ArrivedAt");
            }

            arriveDepartText += this.veriDate.formatDate(
                visit.actualArrivalTime,
                "time"
            );
        }

        if (visit.actualDepartureTime) {
            const departTime = this.veriDate.formatDate(
                visit.actualDepartureTime,
                "time"
            );

            if (visit.actualArrivalTime) {
                const duration = this.veriDate.formatDuration(
                    visit.actualArrivalTime,
                    visit.actualDepartureTime
                );
                arriveDepartText += ` ${this.translationService.t(
                    "Tms.To"
                )} ${departTime} (${duration})`;
            } else {
                arriveDepartText += `${this.translationService.t(
                    "Tms.Departed"
                )} ${departTime}`;
            }
        }

        if (arriveDepartText) {
            entry.largeDetails.listItems.push({ verb: arriveDepartText });
        }

        if (visit.plot && !visit.displayName) {
            entry.largeDetails.location = visit.plot;
        }

        this.timelineEntries.push(entry);
    }
}

export class RouteDetailsComponent implements angular.IComponentOptions {
    bindings: any;
    controller: any;
    template: string;

    constructor() {
        this.bindings = {
            routeId: "<",
        };

        this.controller = RouteDetailsComponentController;
        this.template = require("./routeDetails.component.html");
    }
}
